import globals from "@/utils/globals";
import getLocale from "@/utils/locale";

const state = {
  startTrialButtonCtaHref: globals.startTrialButtonCtaHref || false
};

const getters = {
  startTrialButtonCtaHref: state => {
    return state.startTrialButtonCtaHref;
  }
};

const mutations = {
  updateTrialButtonHref: (state, href) => {
    state.startTrialButtonCtaHref = href;
  }
};

const actions = {
  load: ({ commit }) => {
    commit("updateTrialButtonHref", `/${getLocale()}/onboarding/welcome-wizard`);
  }

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
